import { POST_ABOUT_US_ERROR, POST_ABOUT_US_START, POST_ABOUT_US_SUCCESS } from '../../types';

export default function post_about_us(state, action) {
  switch (action.type) {
    case POST_ABOUT_US_START:
      return { ...state };
    case POST_ABOUT_US_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_ABOUT_US_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
